import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

function Terms() {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("terms.md")
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="container" style={{ padding: "2rem" }}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}

export default Terms;
